module.exports = __webpack_public_path__ + "static/media/edit.a8b46ecf.svg";